import { render, staticRenderFns } from "./ManageCampaignDetails.vue?vue&type=template&id=61551f0a&scoped=true&lang=pug&"
import script from "./ManageCampaignDetails.vue?vue&type=script&lang=js&"
export * from "./ManageCampaignDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61551f0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
